export const updateResourceExplorerVisibilityHierarchyFixedCacheKey =
  "updateResourceExplorerVisibilityHierarchy-fixed-cache-key";
